<template>
  <div>
    <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-toggle="modal"
      data-bs-target="#changeStatusModal" @click.prevent="handleStatusModalOpen">
      <i class="fa-solid fa-arrows-turn-to-dots me-1"></i>
      {{ $t('button_change_status') }}
    </button>
    <div class="modal fade" id="changeStatusModal" tabindex="-1" aria-labelledby="changeStatusModalLabel" aria-hidden="true" ref="modal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="block block-rounded block-transparent mb-0">
            <div class="block-header block-header-default">
              <h3 class="block-title">{{ $t('button_change_status') }}</h3>

              <div class="block-options">
                <button type="button" class="btn btn-sm btn-block-option" @click="toggleInfo()">
                  <i class="fa fa-fw fa-circle-info"></i>
                </button>
                <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>
            </div>
            <div class="block-content fs-sm mb-4">
              <div v-if="showInfoDialog" class="text-muted text-end">
                <!--<p v-for="(toList, fromId) in validTransitions" :key="fromId" class="text-muted text-end">
                {{
                  getStatusTitle(fromId) + ' -> ' + toList.map(getStatusTitle).join('، ')
                }}
              </p>-->
              </div>
              <div class="mb-4">
                <label class="form-label" for="status_select">{{ $t('input_status') }}</label>
                <select id="status_select" class="w-100 form-select" v-model="selectedStatus">
                  <option value="" disabled selected>{{ $t('placeholder_select_status') }}</option>
                  <option v-for="status in changeableShipmentsStatuses" :key="status._id" :value="status._id">
                    {{ status.title_ar }}
                  </option>
                </select>
              </div>

              <!-- User Selection (Only shown for status 5) -->
              <div class="mb-4" v-if="showUserSelect">
                <label class="form-label" for="status_assigned_to_select">{{ $t('input_courier') }}</label>
                <select name="status_assigned_to_select" id="status_assigned_to_select"
                  class="selectpicker show-menu-arrow" data-style="btn-alt-secondary" data-select-all-headers="true"
                  data-size="5" data-selected-text-format="count > 4" data-width="100%" data-actions-box="true"
                  data-live-search="true" data-none-selected-text="Select from" v-model="selectedUser">
                  <optgroup v-for="(userByRole, role) in uniqueGroupedUsers" :key="role" :label="role | capitalize">
                    <option v-for="user in userByRole" :key="user._id" :value="user._id">
                      {{ user.first_name }} {{ user.last_name }}
                    </option>
                  </optgroup>
                </select>
              </div>

              <!-- Grand Total (Only shown for status 9) -->
              <div class="mb-4" v-if="showGrandTotalInput">
                <label for="updated_grand_total">{{ $t('input_grand_total') }}:</label>
                <input class="form-control" type="number" id="updated_grand_total" name="updated_grand_total" min="0"
                  step="1" v-model.number="updatedGrandTotal">
              </div>

              <!-- Hold Till Date (Only shown for status 3) -->
              <div class="mb-4" v-if="showHoldTillDateInput">
                <label for="hold_till_date">{{ $t('input_hold_till') }}:</label>
                <input type="text" class="js-flatpickr form-control js-flatpickr-enabled flatpickr-input active"
                  id="hold_till_date" name="hold_till_date" placeholder="Y-m-d" readonly="readonly"
                  v-model="holdTillDate">
              </div>
            </div>
            <input type="hidden" id="shipment_id">
            <div class="block-content block-content-full-footer bg-body">
              <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">{{
                $t('button_cancel') }}</button>
              <button type="button" id="confirmStatusButton" class="btn btn-sm btn-primary" @click="confirmStatus">{{
                $t('button_submit') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ChangeStatusModal',
  props: {
    changeableShipmentsStatuses: {
      type: Array,
      required: true,
      default: () => []
    },
    grouped_users: {
      type: Object,
      required: true,
      default: () => ({})
    },
    selectedShipments: {
      type: Set,
      required: true,
      default: () => new Set()
    }
  },
  data() {
    return {
      selectedStatus: '',
      selectedUser: '',
      updatedGrandTotal: 0,
      holdTillDate: '',
      shipmentStatuses: [],
      modal: null, // Store the modal instance here
      showInfoDialog: false,
      validTransitions: {
        '1': ['2'],
        '2': ['1', '3', '4', '5', '8'],
        '3': ['2', '4', '8'],
        '4': ['2', '3', '5', '8'],
        '5': ['2', '3', '6', '7', '8', '9', '10'],
        '6': ['2', '4', '5'],
        '7': ['2', '6', '8', '9', '10'],
        '8': ['2', '6', '7', '9', '10'],
        '9': ['2', '6', '7', '8', '10'],
        '10': ['2', '6', '7', '8', '9'],
      },
    }
  },
  computed: {
    showUserSelect() {
      return this.selectedStatus == 5;
    },
    showGrandTotalInput() {
      return this.selectedStatus == 7 || this.selectedStatus == 9;
    },
    showHoldTillDateInput() {
      return this.selectedStatus == 3;
    },
    uniqueGroupedUsers() {
      const uniqueUsers = {};
      const seenIds = new Set();

      for (const [role, users] of Object.entries(this.grouped_users)) {
        uniqueUsers[role] = users.filter(user => {
          if (seenIds.has(user._id)) return false;
          seenIds.add(user._id);
          return true;
        });
      }
      return uniqueUsers;
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  mounted() {
    this.shipmentStatuses = this.changeableShipmentsStatuses;
    // Ensure the modal reference exists before initialization
    this.modal = new bootstrap.Modal(this.$refs.modal); // Ensure $refs.modal is correctly pointing to the modal element
    this.initSelectPicker();
    this.initFlatpickr();

    this.$watch('grouped_users', () => {
      this.refreshSelectPicker();
    }, { deep: true });

    this.$watch('selectedStatus', () => {
      this.refreshSelectPicker();
    });
  },
  watch: {
    selectedStatus(newVal) {
      this.$nextTick(() => {
        if (this.showUserSelect) {
          this.initSelectPicker();
        }
      });
    },
    grouped_users: {
      handler() {
        this.$nextTick(() => {
          if (this.showUserSelect) {
            this.refreshSelectPicker();
          }
        });
      },
      deep: true
    }
  },
  methods: {
    getStatusTitle(id) {
      const status = this.shipmentStatuses.find(s => s._id == id)
      return status ? status.title_ar : `(${id})`
    },
    initSelectPicker() {
      this.$nextTick(() => {
        const selectPicker = $('#status_assigned_to_select');
        if (selectPicker.data('selectpicker')) {
          selectPicker.selectpicker('destroy');
        }
        selectPicker.selectpicker({
          liveSearch: true,
          actionsBox: true
        });
      });
    },
    refreshSelectPicker() {
      this.$nextTick(() => {
        if (this.showUserSelect) {
          const selectPicker = $('#status_assigned_to_select');
          if (selectPicker.data('selectpicker')) {
            selectPicker.selectpicker('destroy');
          }
          this.initSelectPicker();

          if (this.selectedUser) {
            this.$nextTick(() => {
              selectPicker.selectpicker('val', this.selectedUser);
            });
          }
        }
      });
    },
    initFlatpickr() {
      this.$nextTick(() => {
        $('#hold_till_date').flatpickr({
          dateFormat: 'Y-m-d',
          allowInput: true
        });
      });
    },
    confirmStatus() {
      if (this.selectedShipments.size === 0 || this.selectedShipments.length === 0) {
        console.log('No shipments selected');
        this.showWarningNotification(this.$t('message_no_shipments_selected'));
        return;
      }

      if (!this.selectedStatus) {
        this.showErrorNotification(this.$t('message_select_status_and_user'));
        return;
      }

      this.updateShipmentStatus(
        this.selectedShipments,
        this.selectedStatus,
        this.selectedUser,
        this.updatedGrandTotal,
        this.holdTillDate
      );
    },
    resetForm() {
      this.selectedStatus = '';
      this.selectedUser = '';
      this.updatedGrandTotal = 0;
      this.holdTillDate = '';

      this.$nextTick(() => {
        $('#status_assigned_to_select').selectpicker('val', '');
        $('#status_select').val('');
      });
    },
    showWarningNotification(message) {
      Swal.fire({
        icon: 'warning',
        title: this.$t('message_warning'),
        text: message,
        confirmButtonText: this.$t('button_ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      });
    },
    showErrorNotification(message) {
      One.helpers('jq-notify', {
        type: 'danger',
        icon: 'fa fa-exclamation-circle me-1',
        message: message,
      });
    },
    updateShipmentStatus(shipment_ids, selectedValue, selectedUser, updated_grand_total, hold_till_date) {
      One.layout('header_loader_on');
      console.log('Selected Shipments:', shipment_ids);
      axios.post('/shipments/change-status', {
        shipment_ids: Array.from(shipment_ids),
        status_id: selectedValue,
        assigned_to: selectedUser,
        updated_grand_total: updated_grand_total,
        hold_till_date: hold_till_date
      }, {
        headers: {
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        },
      })
        .then(response => {
          if (response.status === 200) {
            this.$emit('status-updated', response.data);
          }
          Swal.fire({
            icon: 'success',
            title: this.$t('message_success'),
            text: this.$t('message_status_updated'),
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: 'btn btn-primary',
            },
          });
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: this.$t('message_error'),
            text: error.response.data.message,
            confirmButtonText: this.$t('button_ok'),
            customClass: {
              confirmButton: 'btn btn-primary',
            },
          });
          console.error('Error updating statuses:', error);
        })
        .finally(() => {
          One.layout('header_loader_off');
          this.resetForm();
        });
    },
    toggleInfo() {
      this.showInfoDialog = !this.showInfoDialog;
      if (this.showInfoDialog) {
        this.$emit('show-info-dialog', true);
      } else {
        this.$emit('show-info-dialog', false);
      }
    },
  }
}
</script>